
export const BASE_URL = "https://app-manager.ihealthlabs.com"//正式环境
// export const BASE_URL = "https://test-env.ihealthlabs.com"//测试环境

export const APP_BASE_URL = "https://dashboard-distribution.ihealthlabs.com/"//正式环境
// export const APP_BASE_URL = "https://test-dashboard-distribution.ihealthlabs.com/"//测试环境

export const VERSION="© 2024, iHealth Labs Inc All rights reserved. (Updated 10/2024-V0.13.1)"

